export const MIN_LINE_HEIGHT = 0.8;

export const normalizeLineHeight = (lineHeight: string | number) => {
  let unit = '';
  if (
    (typeof lineHeight === 'string' && lineHeight.match(/^\d+(\.\d+)?$/)) ||
    typeof lineHeight === 'number'
  ) {
    unit = 'em';
  }
  return `max(${MIN_LINE_HEIGHT}em, ${lineHeight}${unit})`;
};
